const THUMBNAILS_ALIGNMENT = {
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  TOP: 'TOP',
  RIGHT: 'RIGHT',
};

export default THUMBNAILS_ALIGNMENT;
